/**
 * API client for alert/notification endpoints.
 * Uses apiClient (with auth headers) instead of the bare api wrapper.
 */
import apiClient from './apiClient';

// --- Preferences ---
export const getNotificationPreferences = () =>
  apiClient.get('/alerting/preferences');

export const updateNotificationPreferences = (data: Record<string, any>) =>
  apiClient.put('/alerting/preferences', data);

// --- Alert history ---
export interface AlertHistoryParams {
  limit?: number;
  offset?: number;
  alert_type?: string;
  severity?: string;
  status?: string;
  farm_id?: string;
}

export const getAlertHistory = (params?: AlertHistoryParams) => {
  const qs = params
    ? '?' + new URLSearchParams(
        Object.entries(params)
          .filter(([, v]) => v !== undefined)
          .map(([k, v]) => [k, String(v)])
      ).toString()
    : '';
  return apiClient.get(`/alerting/history${qs}`);
};

export const getAlertSummary = () =>
  apiClient.get('/alerting/summary');

export const acknowledgeAlert = (alertId: number, note?: string) =>
  apiClient.post(`/alerting/history/${alertId}/acknowledge`, { acknowledgment_note: note });

export const resolveAlert = (alertId: number, note?: string) =>
  apiClient.post(`/alerting/history/${alertId}/resolve`, { resolution_note: note });

export const acknowledgeAllAlerts = () =>
  apiClient.post('/alerting/history/acknowledge-all');

export const resolveAllAlerts = () =>
  apiClient.post('/alerting/history/resolve-all');

// --- WhatsApp verification ---
export const verifyWhatsAppPhone = (phone: string) =>
  apiClient.post(`/alerting/whatsapp/verify-phone?phone=${encodeURIComponent(phone)}`);

export const confirmWhatsAppCode = (code: string) =>
  apiClient.post(`/alerting/whatsapp/confirm-code?code=${encodeURIComponent(code)}`);

// --- SMS verification ---
export const verifySmsPhone = (phone: string) =>
  apiClient.post(`/alerting/sms/verify-phone?phone=${encodeURIComponent(phone)}`);

export const confirmSmsCode = (code: string) =>
  apiClient.post(`/alerting/sms/confirm-code?code=${encodeURIComponent(code)}`);
